import { ErrorMessage, Field, Form, Formik } from "formik";
import upload from "../assets/img/icons/upload.png";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { RestfullApiService } from "../config/service";
import { createRef, useEffect, useRef, useState } from "react";
import {
  disabledCustomStyle,
  selectCustomStyle,
} from "../utils/selectCustomStyle";
import { format, parseISO } from "date-fns";
import CheckIcon from "../assets/img/icons/check.png";
import DivLoader from "../utils/DivLoader";
import { MEDIA_URL } from "../config/url";
import toast from "react-hot-toast";
import * as Yup from "yup";

import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { Modal, TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useDispatch, useSelector } from "react-redux";
import Cropper from "react-cropper";
import Swal from "sweetalert2";
import "cropperjs/dist/cropper.css";
import { setProfile } from "../redux/slices/userSlice";

const Profile = () => {
  const [fetchingProfile, setFetchingProfile] = useState(false);
  const [updatingUser, setUpdatingUser] = useState(false);
  const [uploadingImage, setUploadingImage] = useState(false);
  const [open, setOpen] = useState(false);
  const userData = useSelector((state) => state.user);
  const user = useSelector((state) => state.user.userProfile);
  const dispatch = useDispatch();

  const genderRef = useRef(null);
  const bloodGroupRef = useRef(null);
  const dobRef = useRef(null);
  const pincodeRef = useRef(null);
  const cityRef = useRef(null);
  const stateRef = useRef(null);
  const addressRef = useRef(null);
  const fieldRefMap = {
    Gender: genderRef,
    Blood_Group: bloodGroupRef,
    Date_Of_Birth: dobRef,
    Pincode: pincodeRef,
    State_Id: stateRef,
    City_Id: cityRef,
    Address: addressRef,
  };

  const initialValues = {
    Profile_Image_Path: "",
    Name: "",
    Phone_Number: "",
    Email_Id: "",
    Gender: "",
    Date_Of_Birth: "",
    Blood_Group: {},
    Address: "",
    Street: "",
    Landmark: "",
    City_Id: "",
    State_Id: "",
    Country_Id: { label: "India", value: "India" },
    Pincode: null,
    ID_Proof_Type: {},
    ID_Proof: null,
    Emergency_Contact_Name: "",
    Emergency_Contact_Number: "",
  };
  const validationSchema = Yup.object().shape({
    Profile_Image_Path: Yup.string().nullable(),
    Name: Yup.string().required("Name is required"),
    Phone_Number: Yup.string()
      .matches(/^[0-9]+$/, "Phone number is not valid")
      .required("Phone number is required"),
    Email_Id: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    Gender: Yup.string().required("Gender is required"),
    Date_Of_Birth: Yup.date().required("Date of Birth is required").nullable(),
    Blood_Group: Yup.object().required("Blood Group is required"),
    Address: Yup.string().required("Address is required"),
    Street: Yup.string().nullable(),
    Landmark: Yup.string().nullable(),
    City_Id: Yup.string().required("City is required"),
    State_Id: Yup.string().required("State is required"),
    Country_Id: Yup.object().required("Country is required"),
    Pincode: Yup.object().required("Pincode is required"),
    // Pincode: Yup.object()
    //   .shape({
    //     value: Yup.string().required("Pincode is required"),
    //   })
    //   .required("Pincode is required"),
    ID_Proof_Type: Yup.object().nullable(),
    // ID_Proof: Yup.object().nullable(),
    Emergency_Contact_Name: Yup.string().nullable(),
    Emergency_Contact_Number: Yup.string()
      .matches(/^[0-9]+$/, "Emergency contact number is not valid")
      .test(
        "uniquePhoneNumber",
        "Emergency contact number must be different from the Participant number",
        (value) => {
          return value !== user?.Phone_Number;
        }
      )
      .nullable(),
  });
  const [initialFormValues, setInitialFormValues] = useState(initialValues);
  const [image, setImage] = useState(null);
  const [openCropper, setOpenCropper] = useState(false);
  const cropperRef = createRef();

  const handleFileChange = async (event) => {
    const file = event.currentTarget.files[0];

    // Check if the file is an image
    if (file && !file.type.startsWith("image/")) {
      toast.error("Please upload an image.");
      event.target.value = ""; // Reset the input value
      return;
    }
    // Check if the file size is above 2MB (2 * 1024 * 1024 bytes)
    const maxSize = 2 * 1024 * 1024;
    if (file && file.size > maxSize) {
      toast.error("File size should not exceed 2MB.");
      event.target.value = ""; // Reset the input value
      return;
    }

    if (file instanceof Blob) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
        setOpenCropper(true); // Open the modal
      };
      reader.readAsDataURL(file);
    } else {
      console.log("Not");
      return;
    }
  };
  const zoomIn = () => {
    if (cropperRef.current) {
      cropperRef.current.cropper.zoom(0.1); // Zoom in by 0.1
    }
  };
  const zoomOut = () => {
    if (cropperRef.current) {
      cropperRef.current.cropper.zoom(-0.1); // Zoom out by 0.1
    }
  };
  const getCropData = async (setFieldValue, setUploadingImage) => {
    if (typeof cropperRef.current?.cropper !== "undefined") {
      const croppedImage = cropperRef.current?.cropper
        .getCroppedCanvas()
        .toDataURL();

      // Convert base64 to file
      const blob = await (await fetch(croppedImage)).blob();
      const croppedFile = new File([blob], "croppedImage.png", {
        type: "image/png",
      });

      const reqdata = new FormData();
      reqdata.append("ModuleName", "UserProfileImage");
      reqdata.append("File", croppedFile);

      // Start uploading
      setUploadingImage(true);

      try {
        await toast.promise(
          RestfullApiService(reqdata, "participant/uploadfile"),
          {
            loading: "Uploading Image...",
            success: (result) => {
              if (result) {
                console.log(result);
                setFieldValue("Profile_Image_Path", result?.data?.Description);
              }
              return "Image uploaded successfully! Please save your changes!";
            },
            error: (err) => {
              const errorMessage =
                err?.Result?.Table1[0]?.Result_Description || "Upload failed";
              return errorMessage;
            },
          },
          {
            success: {
              duration: 5000,
            },
          }
        );
      } catch (error) {
        console.error("Upload failed:", error);
      } finally {
        // End uploading
        setUploadingImage(false);
        setOpenCropper(false); // Close the modal
      }
    }
  };

  const blood_group = [
    { label: "A+", value: "A+" },
    { label: "A-", value: "A-" },
    { label: "B+", value: "B+" },
    { label: "B-", value: "B-" },
    { label: "O+", value: "O+" },
    { label: "O-", value: "O-" },
    { label: "AB+", value: "AB+" },
    { label: "AB-", value: "AB-" },
  ];
  const id_proof = [
    { label: "Aadhar Card", value: "Aadhar Card" },
    { label: "PAN Card", value: "PAN Card" },
  ];
  const convertDateFormat = (isoDateString) => {
    const parsedDate = parseISO(isoDateString); // Parse the ISO string to a Date object
    return format(parsedDate, "yyyy-MM-dd"); // Format the Date object to yyyy-MM-dd
  };
  const handlePhoneChange = (phone, setFieldValue) => {
    // Remove the country code (+91)
    const phoneWithoutCountryCode = phone.replace(/^\+91/, "");
    // Remove hyphens and add spaces
    const formattedPhone = phone.replace(/-/g, " ");
    setFieldValue("Phone_Number", phoneWithoutCountryCode);
  };
  const getProfile = async () => {
    // const user = JSON.parse(localStorage.getItem("userProf"));
    const reqdata = {
      Method_Name: "MyInfo",
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      Filter: user?.Participant_Id,
    };
    try {
      setFetchingProfile(true);
      const result = await RestfullApiService(
        reqdata,
        "participant/Profile_get"
      );
      if (result) {
        console.log(result?.data);
        const formResult = result?.data?.Result?.Table1[0];
        localStorage.setItem(
          "user",
          JSON.stringify(result?.data?.Result?.Table1[0])
        );

        const nameParts = [
          formResult?.First_Name,
          formResult?.Middle_Name,
          formResult?.Last_Name,
        ]
          .filter((part) => part)
          .join(" ");
        console.log(nameParts);

        setInitialFormValues({
          ...formResult,
          Blood_Group: blood_group.find(
            (group) => group?.value === formResult?.Blood_Group
          ),
          ID_Proof_Type: id_proof.find(
            (type) => type?.value === formResult?.ID_Proof_Type_Id
          ),
          ID_Proof: formResult?.ID_Proof_Path ? formResult?.ID_Proof_Path : "",
          Name: nameParts,
          Gender:
            formResult?.Gender === "M"
              ? "Male"
              : formResult?.Gender === "F"
              ? "Female"
              : formResult?.Gender === "O"
              ? "Other"
              : "",
          Date_Of_Birth: formResult?.Date_Of_Birth
            ? convertDateFormat(formResult?.Date_Of_Birth)
            : "",
          Pincode: formResult?.Pincode
            ? { label: formResult?.Pincode, value: formResult?.Pincode_Id }
            : undefined,
          Country_Id: { label: "India", value: "India" },
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setFetchingProfile(false);
    }
  };
  const updateProfile = async (values) => {
    // const user = JSON.parse(localStorage.getItem("userProf"));
    const userName = values?.Name?.split(" ");

    console.log(userName);

    let reqdata = {
      ...values,
      Method_Name: "update",
      Date_Of_Birth: dayjs(values?.Date_Of_Birth).format("YYYY-MM-DD"),
      Pincode: String(values?.Pincode?.value),
      Blood_Group: values?.Blood_Group?.value,
      ID_Proof_Type: values?.ID_Proof_Type?.value,
      ID_Proof_Path: values?.ID_Proof,
      ID_Proof_Type_Id: values?.ID_Proof_Type?.value,
      ID_Proof_Name: values?.ID_Proof_Name?.value,
      Country_Id: values?.Country_Id?.value,
      Gender:
        values?.Gender === "Male"
          ? "M"
          : values?.Gender === "Female"
          ? "F"
          : "O",
      Is_Medical_Fit: 1,
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      // First_Name: userName[0] ?? "",
      First_Name: values?.Name,
      Middle_Name: "",
      Last_Name: "",
      // Filter: user?.Participant_Id,
    };
    const updatedProfile = { ...user, ...reqdata };

    console.log(reqdata);
    const response = {
      userProfile: updatedProfile,
      token: userData?.token,
      we3_key: userData?.we3key,
    };

    try {
      setUpdatingUser(true);
      const result = await RestfullApiService(
        reqdata,
        "participant/update_profile"
      );
      if (result) {
        dispatch(setProfile(response));
        console.log(result?.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      // Show SweetAlert after submission
      Swal.fire({
        title: "Thank you!",
        text: "Your profile has been updated.",
        icon: "success",
        confirmButtonColor: "#f05736",
        confirmButtonText: "OK",
      }).then(() => {
        // Reset the form after SweetAlert is closed
        getProfile();
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
      setUpdatingUser(false);
    }
  };
  const fetchOptions = async (inputValue) => {
    if (inputValue.length !== 6) {
      return [];
    }

    try {
      const reqdata = {
        Method_Name: "pincode",
        Org_Id: user?.Org_Id,
        Session_User_Id: user?.Participant_Id,
        Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
        Option1: inputValue,
        Option2: "string",
        Option3: "string",
      };
      const response = await RestfullApiService(reqdata, "master/Par_dropdown");

      console.log(response?.data);

      return response.data.Result.Table1.map((option) => ({
        label: option.label,
        value: option.value,
      }));
    } catch (error) {
      console.error("Error fetching options:", error);
      return [];
    }
  };
  const fetchLocation = async (inputValue, setFieldValue, setFieldTouched) => {
    try {
      const reqdata = {
        Method_Name: "plocation",
        Org_Id: user?.Org_Id,
        Session_User_Id: user?.Participant_Id,
        Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
        Option1: String(inputValue),
        Option2: "string",
        Option3: "string",
      };
      const response = await RestfullApiService(reqdata, "master/Par_dropdown");

      console.log(response?.data);
      const data = response?.data?.Result?.Table1[0];

      setFieldValue("State_Id", data?.StateName);
      setFieldValue("City_Id", data?.District);
      setFieldValue("Address", data?.OfficeName);
      setTimeout(() => {
        setFieldTouched("State_Id", true);
        setFieldTouched("City_Id", true);
        setFieldTouched("Address", true);
      });
    } catch (error) {
      console.error("Error fetching options:", error);
      return [];
    }
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    getProfile();
  }, []);

  return (
    <>
      <div className="row y-gap-20 justify-between items-end pb-20 lg:pb-20 md:pb-10">
        <div className="col-auto">
          <h1 className="text-20 lh-14 fw-600">
            Hi 👋 {user?.First_Name} !{" "}
            <span className="text-primary">Update your Profile</span>
          </h1>
        </div>
        <div className="col-auto"></div>
      </div>
      {fetchingProfile && (
        <div className="mt-50 h-20vh relative">
          <DivLoader />
        </div>
      )}
      {!fetchingProfile && (
        <Formik
          enableReinitialize
          initialValues={initialFormValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            console.log("asdfsafdsad");
            updateProfile(values);
          }}
        >
          {({
            errors,
            submitForm,
            validateForm,
            isValid,
            touched,
            dirty,
            setFieldValue,
            setFieldTouched,
            setTouched,
            values,
          }) => (
            <Form>
              <div className="py-30 px-30 lg:px-15 rounded-4 bg-white shadow-2">
                <div className="tabs -underline-2 js-tabs">
                  <div className="tabs__content js-tabs-content">
                    <div className="tabs__pane -tab-item-1 is-tab-el-active">
                      <div className="row y-gap-30 items-center">
                        <div className="col-md-4 d-flex justify-center items-center">
                          <div className="d-flex ratio ratio-1:1 w-200 rounded-full border-primary overflow-hidden profile-img">
                            <img
                              src={
                                user?.Login_Type === "2" &&
                                values?.Profile_Image_Path &&
                                values?.Profile_Image_Path.includes(
                                  "googleusercontent.com"
                                )
                                  ? values?.Profile_Image_Path
                                  : // user?.Login_Type === "1" &&
                                  values?.Profile_Image_Path
                                  ? `${MEDIA_URL}${values?.Profile_Image_Path}`
                                  : upload
                              }
                              // src={values?.Profile_Image_Path}
                              alt="profile"
                              className="img-ratio"
                            />
                            <Field name="Profile_Image_Path">
                              {({ field }) => (
                                <input
                                  name="Profile_Image_Path"
                                  type="file"
                                  className="upload-pdf"
                                  accept="image/*"
                                  style={{
                                    zIndex: 1,
                                    opacity: 0,
                                    position: "absolute",
                                    height: "100%",
                                    width: "100%",
                                  }}
                                  onChange={handleFileChange}
                                />
                              )}
                            </Field>
                            <Modal open={openCropper} onClose={() => {}}>
                              <div
                                style={{
                                  position: "absolute",
                                  left: "50%",
                                  top: "20%",
                                  width: "650px",
                                  maxWidth: "100%",
                                  height: "auto",
                                  transform: "translateX(-50%)",
                                  padding: "20px",
                                  backgroundColor: "white",
                                }}
                              >
                                <div className="d-flex flex-column items-end mb-10">
                                  <button
                                    class="pointer"
                                    onClick={() => {
                                      setOpenCropper(false);
                                    }}
                                  >
                                    <i class="far fa-times-circle text-primary text-25"></i>
                                  </button>
                                </div>
                                <div
                                  style={{
                                    position: "relative",
                                    height: "300px",
                                  }}
                                >
                                  <Cropper
                                    style={{
                                      maxWidth: "100%",
                                      height: "300px", // Set a fixed height for the cropper
                                      objectFit: "contain", // Ensures the image fits within the cropper
                                    }}
                                    ref={cropperRef}
                                    zoomTo={0.5}
                                    initialAspectRatio={1} // Set the initial aspect ratio to 2:1
                                    aspectRatio={1} // Maintain the aspect ratio of 2:1
                                    minCropBoxWidth={800}
                                    minCropBoxHeight={50}
                                    preview=".img-preview"
                                    src={image}
                                    viewMode={1}
                                    // minCropBoxHeight={10}
                                    // minCropBoxWidth={10}
                                    background={false}
                                    responsive={true}
                                    autoCropArea={1}
                                    checkOrientation={false}
                                    guides={true}
                                  />

                                  {/* Zoom buttons positioned at the top right corner */}
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "10px",
                                      right: "10px",
                                    }}
                                  >
                                    <div className="d-flex gap-10">
                                      <button
                                        onClick={zoomIn}
                                        className="button h-30 w-30 px-5 text-black bg-white -grey-1 rounded-8"
                                      >
                                        <i class="fas fa-search-plus text-primary text-14"></i>
                                      </button>
                                      <button
                                        onClick={zoomOut}
                                        className="button h-30 w-30 px-5 text-black bg-white -grey-1 rounded-8"
                                      >
                                        <i class="fas fa-search-minus text-primary text-14"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex flex-column items-end mb-10">
                                  <button
                                    disabled={uploadingImage}
                                    onClick={async (e) => {
                                      getCropData(
                                        setFieldValue,
                                        setUploadingImage
                                      );
                                    }}
                                    type="submit"
                                    className="button h-50 px-30 text-white bg-primary -grey-1 rounded-16 load-button relative w-200 mt-20"
                                  >
                                    {!uploadingImage && "Crop & Upload"}
                                    {uploadingImage && (
                                      <span class="btn-spinner"></span>
                                    )}
                                  </button>
                                </div>
                              </div>
                            </Modal>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row justify-between">
                            <div className="col-12">
                              <div className="single-field">
                                <label className="text-13 fw-600">
                                  Full Name <sup className="asc">*</sup>
                                </label>
                                <div className="form-control">
                                  <Field
                                    disabled
                                    type="text"
                                    name="Name"
                                    className="form-control"
                                    placeholder="Full name"
                                  />
                                </div>
                                <ErrorMessage
                                  className="text-error-2 text-13"
                                  name="Name"
                                  component="div"
                                />
                              </div>
                            </div>
                            <div className="col-12 pt-10">
                              <div className="single-field">
                                <label className="text-13 fw-600">
                                  Phone Number <sup className="asc">*</sup>
                                </label>
                                <div className="form-control relative">
                                  <PhoneInput
                                    disabled
                                    disableDialCodePrefill
                                    disableDialCodeAndPrefix
                                    showDisabledDialCodeAndPrefix
                                    placeholder="00000-00000"
                                    defaultCountry="in"
                                    value={values.Phone_Number}
                                    onChange={(phone, e) => {
                                      // formik.setFieldValue("phone", phone);
                                      handlePhoneChange(phone, setFieldValue);
                                    }}
                                    inputStyle={{
                                      borderLeft: "0px",
                                    }}
                                    countrySelectorStyleProps={{
                                      paddingRight: "8px",
                                      paddingLeft: "8px",
                                    }}
                                  />
                                  <img
                                    src={CheckIcon}
                                    alt="check"
                                    class="input-icon absolute r-0"
                                    width="20"
                                  />
                                </div>
                                <ErrorMessage
                                  className="text-error-2 text-13"
                                  name="Phone_Number"
                                  component="div"
                                />
                              </div>
                            </div>
                            <div className="col-12 pt-10">
                              <div className="single-field">
                                <label className="text-13 fw-600">
                                  Email <sup className="asc">*</sup>
                                </label>
                                <div className="form-control relative">
                                  <Field
                                    disabled
                                    type="email"
                                    name="Email_Id"
                                    className="form-control"
                                    placeholder="info@yourgmail.com"
                                  />
                                  <img
                                    src={CheckIcon}
                                    alt="check"
                                    class="input-icon absolute r-0"
                                    width="20"
                                  />
                                </div>
                                <ErrorMessage
                                  className="text-error-2 text-13"
                                  name="Email_Id"
                                  component="div"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="border-top-light mt-30 mb-30"></div>
                      <div className="col-xl-10">
                        <div className="row x-gap-20 y-gap-20">
                          <div className="col-md-4">
                            <div className="single-field y-gap-20">
                              <label className="text-13 fw-600">
                                Gender <sup className="asc">*</sup>
                              </label>

                              <div className="d-flex gap-15">
                                <div className="form-radio d-flex items-center">
                                  <div className="radio">
                                    <Field
                                      type="radio"
                                      name="Gender"
                                      value="Male"
                                      innerRef={genderRef}
                                    />
                                    <div className="radio__mark">
                                      <div className="radio__icon"></div>
                                    </div>
                                  </div>
                                  <div className="text-14 lh-1 ml-10">Male</div>
                                </div>
                                <div className="form-radio d-flex items-center">
                                  <div className="radio">
                                    <Field
                                      type="radio"
                                      name="Gender"
                                      value="Female"
                                      innerRef={genderRef}
                                    />
                                    <div className="radio__mark">
                                      <div className="radio__icon"></div>
                                    </div>
                                  </div>
                                  <div className="text-14 lh-1 ml-10">
                                    Female
                                  </div>
                                </div>
                                <div className="form-radio d-flex items-center">
                                  <div className="radio">
                                    <Field
                                      type="radio"
                                      name="Gender"
                                      value="Other"
                                      innerRef={genderRef}
                                    />
                                    <div className="radio__mark">
                                      <div className="radio__icon"></div>
                                    </div>
                                  </div>
                                  <div className="text-14 lh-1 ml-10">
                                    Other
                                  </div>
                                </div>
                              </div>
                              <ErrorMessage
                                className="text-error-2 text-13"
                                name="Gender"
                                component="div"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="y-gap-20">
                              <label className="text-13 fw-600">
                                Blood Group <sup className="asc">*</sup>
                              </label>
                              <div className="p-0">
                                <Field
                                  name="Blood_Group"
                                  innerRef={bloodGroupRef}
                                >
                                  {({ field }) => (
                                    <Select
                                      placeholder="Select"
                                      styles={selectCustomStyle}
                                      onChange={(e) => {
                                        setFieldValue(field.name, e);
                                      }}
                                      // isSearchable={false}
                                      options={blood_group}
                                      value={values?.Blood_Group}
                                    />
                                  )}
                                </Field>
                              </div>
                              <ErrorMessage
                                className="text-error-2 text-13"
                                name="Blood_Group"
                                component="div"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="single-field y-gap-20">
                              <label className="text-13 fw-600">
                                Date Of Birth <sup className="asc">*</sup>
                              </label>
                              <div className="form-control">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <DesktopDatePicker
                                    className="form-control"
                                    name="Date_Of_Birth"
                                    format="DD/MM/YYYY"
                                    inputFormat="DD/MM/YYYY"
                                    disableFuture
                                    maxDate={dayjs().subtract(8, "year")}
                                    value={
                                      values.Date_Of_Birth
                                        ? dayjs(values.Date_Of_Birth)
                                        : null
                                    }
                                    onChange={(newValue) => {
                                      setFieldValue("Date_Of_Birth", newValue);
                                    }}
                                    open={open}
                                    onOpen={() => setOpen(true)}
                                    onClose={() => setOpen(false)}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        sx={{
                                          fontFamily:
                                            "Montserrat, sans-serif !important",
                                          "& .MuiButtonBase-root": {
                                            color: "orange",
                                          },
                                        }}
                                        fullWidth
                                        className="form-control"
                                      />
                                    )}
                                    slotProps={{
                                      inputAdornment: {
                                        position: "end",
                                      },
                                      textField: {
                                        onClick: () => setOpen(true),
                                      },
                                      field: {
                                        // disabled: true,
                                        readOnly: true,
                                      },
                                      // To change styles
                                      openPickerIcon: {
                                        sx: {
                                          color: "#f05736",
                                        },
                                      },
                                    }}
                                    ref={dobRef}
                                    // To change Icon
                                    // slots={{
                                    //   openPickerIcon: () => (
                                    //     <img
                                    //       src={DateIcon}
                                    //       alt="date-icon"
                                    //       style={{ cursor: "pointer" }}
                                    //       onClick={() => setOpen(true)}
                                    //     />
                                    //   ),
                                    // }}
                                  />
                                </LocalizationProvider>
                              </div>
                              <ErrorMessage
                                className="text-error-2 text-13"
                                name="Date_Of_Birth"
                                component="div"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="border-top-light mt-30 mb-30"></div>
                      <div className="col-xl-10">
                        <div className="row x-gap-20 y-gap-20">
                          <div className="col-md-6 pt-20">
                            <div className="single-field y-gap-20">
                              <label className="text-13 fw-600">
                                Pincode/Zipcode/Postcode{" "}
                                <sup className="asc">*</sup>
                              </label>
                              <div className="p-0">
                                <Field name="Pincode" innerRef={pincodeRef}>
                                  {({ field }) => (
                                    <AsyncSelect
                                      ref={pincodeRef}
                                      name="Pincode"
                                      className="select-color"
                                      placeholder="Pincode"
                                      cacheOptions
                                      loadOptions={fetchOptions}
                                      styles={selectCustomStyle}
                                      onChange={(e) => {
                                        setFieldValue(field.name, e);
                                        if (e === null || e === undefined) {
                                          console.log("Select cleared");
                                          // Run your custom function here
                                          setFieldValue("State_Id", "");
                                          setFieldValue("City_Id", "");
                                          setFieldValue("Address", "");
                                          setTimeout(() => {
                                            setFieldTouched("State_Id", true);
                                            setFieldTouched("City_Id", true);
                                            setFieldTouched("Address", true);
                                          });
                                        } else {
                                          console.log(e);
                                          if (e) {
                                            fetchLocation(
                                              e.value,
                                              setFieldValue,
                                              setFieldTouched
                                            );
                                          }
                                        }
                                      }}
                                      value={values?.Pincode}
                                      isClearable
                                    />
                                  )}
                                </Field>
                              </div>
                              <ErrorMessage
                                className="text-error-2 text-13"
                                name="Pincode"
                                component="div"
                              />
                            </div>
                          </div>
                          <div className="col-md-6 pt-20">
                            <div className="single-field y-gap-20">
                              <label className="text-13 fw-600">
                                Country <sup className="asc">*</sup>
                              </label>
                              <div className="p-0">
                                <Field disabled name="Country_Id">
                                  {({ field }) => (
                                    <Select
                                      isDisabled
                                      placeholder="Country"
                                      styles={disabledCustomStyle}
                                      onChange={(e) => {
                                        setFieldValue(field.name, e);
                                      }}
                                      options={[
                                        {
                                          label: "India",
                                          value: "India",
                                        },
                                      ]}
                                      value={values?.Country_Id}
                                    />
                                  )}
                                </Field>
                              </div>
                              <ErrorMessage
                                className="text-error-2 text-13"
                                name="Country_Id"
                                component="div"
                              />
                            </div>
                          </div>
                          {/* <div className="col-md-6 pt-20">
                            <div className="single-field y-gap-20">
                              <label className="text-13 fw-600">Country</label>
                              <div className="form-control">
                                <Field
                                  type="text"
                                  name="Country_Id"
                                  className="form-control"
                                  placeholder="Country"
                                />
                              </div>
                            </div>
                          </div> */}
                          <div className="col-md-6 pt-20">
                            <div className="single-field y-gap-20">
                              <label className="text-13 fw-600">
                                State <sup className="asc">*</sup>
                              </label>
                              <div className="form-control">
                                <Field
                                  disabled
                                  type="text"
                                  name="State_Id"
                                  className="form-control"
                                  placeholder="State"
                                  innerRef={stateRef}
                                />
                              </div>
                              <ErrorMessage
                                className="text-error-2 text-13"
                                name="State_Id"
                                component="div"
                              />
                            </div>
                          </div>
                          <div className="col-md-6 pt-20">
                            <div className="single-field y-gap-20">
                              <label className="text-13 fw-600">
                                City <sup className="asc">*</sup>
                              </label>
                              <div className="form-control">
                                <Field
                                  disabled
                                  type="text"
                                  name="City_Id"
                                  className="form-control"
                                  placeholder="City"
                                  innerRef={cityRef}
                                />
                              </div>
                              <ErrorMessage
                                className="text-error-2 text-13"
                                name="City_Id"
                                component="div"
                              />
                            </div>
                          </div>
                          <div className="col-md-6 pt-20">
                            <div className="single-field y-gap-20">
                              <label className="text-13 fw-600">Street</label>
                              <div className="form-control">
                                <Field
                                  type="text"
                                  name="Street"
                                  className="form-control"
                                  placeholder="Street"
                                  maxLength="100"
                                  onChange={(e) => {
                                    e.preventDefault();
                                    const { value } = e.target;

                                    const regex =
                                      /^[a-zA-Z0-9!-\/:-@[-`{-~][a-zA-Z0-9\s!-\/:-@[-`{-~]*$/;

                                    if (
                                      !value ||
                                      regex.test(value.toString())
                                    ) {
                                      setFieldValue("Street", value);
                                    } else {
                                      return;
                                    }
                                  }}
                                />
                              </div>
                              <ErrorMessage
                                className="text-error-2 text-13"
                                name="Street"
                                component="div"
                              />
                            </div>
                          </div>
                          <div className="col-md-6 pt-20">
                            <div className="single-field y-gap-20">
                              <label className="text-13 fw-600">
                                Address Line 1 <sup className="asc">*</sup>
                              </label>
                              <div className="form-control">
                                <Field
                                  type="text"
                                  name="Address"
                                  className="form-control"
                                  placeholder="Full Address"
                                  maxLength="100"
                                  onChange={(e) => {
                                    e.preventDefault();
                                    const { value } = e.target;

                                    // Regular expression to allow alphanumeric characters and spaces but no leading spaces
                                    const regex =
                                      /^[a-zA-Z0-9!-\/:-@[-`{-~][a-zA-Z0-9\s!-\/:-@[-`{-~]*$/;
                                    if (
                                      !value ||
                                      regex.test(value.toString())
                                    ) {
                                      console.log("Here");
                                      setFieldValue("Address", value);
                                    } else {
                                      return;
                                    }
                                  }}
                                  innerRef={addressRef}
                                />
                              </div>
                              <ErrorMessage
                                className="text-error-2 text-13"
                                name="Address"
                                component="div"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="single-field y-gap-20">
                              <label className="text-13 fw-600">
                                Address Line 2
                              </label>
                              <div className="form-control">
                                <Field
                                  type="text"
                                  name="Landmark"
                                  className="form-control"
                                  placeholder="Landmark"
                                  maxLength="100"
                                  onChange={(e) => {
                                    e.preventDefault();
                                    const { value } = e.target;

                                    const regex =
                                      /^[a-zA-Z0-9!-\/:-@[-`{-~][a-zA-Z0-9\s!-\/:-@[-`{-~]*$/;

                                    if (
                                      !value ||
                                      regex.test(value.toString())
                                    ) {
                                      setFieldValue("Landmark", value);
                                    } else {
                                      return;
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="border-top-light mt-30 mb-30"></div>
                      <div className="col-xl-10">
                        <div className="row x-gap-20 y-gap-20">
                          <div className="col-md-6">
                            <div className="single-field y-gap-20">
                              <label className="text-13 fw-600">
                                ID Proof Upload
                              </label>
                              <div className="p-0">
                                <Field name="ID_Proof_Type">
                                  {({ field }) => (
                                    <Select
                                      placeholder="Ex. (PAN card, Aadhar Card)"
                                      styles={selectCustomStyle}
                                      onChange={(e) => {
                                        setFieldValue(field.name, e);
                                      }}
                                      // isSearchable={false}
                                      options={id_proof}
                                      value={values?.ID_Proof_Type}
                                    />
                                  )}
                                </Field>
                              </div>
                              {/* <ErrorMessage
                                className="text-error-2 text-13"
                                name="ID_Proof_Type"
                                component="div"
                              /> */}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="single-field y-gap-20 upload">
                              <label className="text-13 fw-600">Id Proof</label>

                              <div className="d-flex items-center p-0">
                                <div className="d-flex items-center p-0">
                                  <div
                                    className="form-control d-flex items-center"
                                    style={{ width: "inherit" }}
                                  >
                                    <Field name="ID_Proof">
                                      {({ field }) => (
                                        <>
                                          <button className="upload__btn">
                                            Upload a file
                                          </button>
                                          <input
                                            type="file"
                                            // {...field}
                                            className="form-control upload__input"
                                            onChange={async (event) => {
                                              const file =
                                                event.currentTarget.files[0];
                                              // Check if the file size is above 2MB (2 * 1024 * 1024 bytes)
                                              const maxSize = 2 * 1024 * 1024;
                                              if (file && file.size > maxSize) {
                                                toast.error(
                                                  "File size should not exceed 2MB."
                                                );
                                                event.target.value = ""; // Reset the input value
                                                return;
                                              }
                                              const reqdata = new FormData();
                                              reqdata.append(
                                                "ModuleName",
                                                `IdProofParticipant`
                                              );
                                              reqdata.append(
                                                "File",
                                                event.currentTarget.files[0]
                                              );
                                              toast.promise(
                                                RestfullApiService(
                                                  reqdata,
                                                  "participant/uploadfile"
                                                ),
                                                {
                                                  loading:
                                                    "Uploading ID Proof... Please wait",
                                                  success: (result) => {
                                                    if (result) {
                                                      console.log(result);
                                                      setFieldValue(
                                                        field.name,
                                                        result?.data
                                                          ?.Description
                                                      );
                                                      // const reqvalues = {
                                                      //   ...values,
                                                      //   ID_Proof:
                                                      //     result?.data
                                                      //       ?.Description,
                                                      // };
                                                      // updateProfile(reqvalues);
                                                    }
                                                    return "Upload successful! Please save your changes!";
                                                  },
                                                  error: (err) => {
                                                    const errorMessage =
                                                      err?.Result?.Table1[0]
                                                        ?.Result_Description ||
                                                      "Upload failed";
                                                    return errorMessage;
                                                  },
                                                }
                                              );
                                            }}
                                          />
                                        </>
                                      )}
                                    </Field>
                                  </div>
                                </div>
                                <a
                                  href={`${MEDIA_URL}${values?.ID_Proof}`}
                                  target="_blank"
                                  class="text-14 lh-12 ml-10 mr-15 underline text-primary"
                                  style={{ zIndex: 2 }}
                                  rel="noreferrer"
                                >
                                  {values?.ID_Proof
                                    ? `...${values?.ID_Proof?.slice(
                                        values?.ID_Proof?.length - 25
                                      )}`
                                    : ""}
                                </a>
                              </div>
                              <p className="text-10 fw-500 pt-10 text-light">
                                jpeg or png smaller than 2 mb
                              </p>
                            </div>
                          </div>
                          <div className="col-md-6 pt-20">
                            <div className="single-field y-gap-20">
                              <label className="text-13 fw-600">
                                Emergency Contact Name
                              </label>
                              <div className="form-control">
                                <Field
                                  type="text"
                                  name="Emergency_Contact_Name"
                                  className="form-control"
                                  placeholder="Contact Name"
                                  onChange={(e) => {
                                    e.preventDefault();
                                    const { value } = e.target;

                                    const regex =
                                      /^[a-zA-Z][a-zA-Z\s!-\/:-@[-`{-~]*$/;

                                    if (
                                      !value ||
                                      regex.test(value.toString())
                                    ) {
                                      setFieldValue(
                                        "Emergency_Contact_Name",
                                        value
                                      );
                                    } else {
                                      return;
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6 pt-20">
                            <div className="single-field y-gap-20">
                              <label className="text-13 fw-600">
                                Emergency Contact Number
                              </label>
                              <div className="form-control">
                                <Field
                                  type="text"
                                  name="Emergency_Contact_Number"
                                  className="form-control"
                                  placeholder="Contact Number"
                                  maxLength="10"
                                  onChange={(e) => {
                                    e.preventDefault();
                                    const { value } = e.target;

                                    // Regular expression to allow only numbers
                                    const regex = /^[0-9\b]+$/;

                                    if (
                                      !value ||
                                      regex.test(value.toString())
                                    ) {
                                      setFieldValue(
                                        "Emergency_Contact_Number",
                                        value
                                      );
                                    } else {
                                      return;
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-inline-block pt-40">
                        <button
                          disabled={updatingUser}
                          onClick={async (e) => {
                            e.preventDefault(); // Prevent default form submission

                            const formErrors = await validateForm(); // Manually trigger validation
                            // Mark all fields as touched to trigger error messages
                            setTouched(
                              Object.keys(initialValues).reduce(
                                (acc, key) => ({ ...acc, [key]: true }),
                                {}
                              )
                            );

                            if (Object.keys(formErrors).length > 0) {
                              console.log(formErrors);
                              window.scrollTo({ top: 0, behavior: "smooth" });
                              toast.error("Please fill required details");

                              // Scroll to the first error field
                              const firstErrorKey = Object.keys(formErrors)[0];
                              const firstErrorRef = fieldRefMap[firstErrorKey];
                              if (firstErrorRef && firstErrorRef.current) {
                                firstErrorRef.current.scrollIntoView({
                                  behavior: "smooth",
                                  block: "center",
                                });
                              }
                            } else {
                              submitForm();
                            }
                          }}
                          type="submit"
                          className="button h-50 px-30 text-white bg-primary -grey-1 rounded-25 load-button relative w-200"
                        >
                          {!updatingUser && "Save Changes"}
                          {updatingUser && <span class="btn-spinner"></span>}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      )}
    </>
  );
};

export default Profile;

// const formErrors = await validateForm();
// if (Object.keys(formErrors).length > 0) {
//   console.log(formErrors);
//   window.scrollTo({ top: 0, behavior: "smooth" });
//   toast.error("Please fill required details");
// } else {
//   submitForm();
// }
// e.preventDefault(); // Prevent default form submission
// if (errors) {
//   console.log(errors);
//   console.log(Object.keys(errors));
//   if (Object.keys(errors).length > 0) {
//     toast.error("Please fill required details");
//   }
// }
// try {
//   const formErrors = await validateForm();

//   // Check if all errors are "cannot be null"
//   const allNullErrors = Object.values(
//     formErrors
//   ).every(
//     (error) =>
//       typeof error === "string" &&
//       error.includes("cannot be null")
//   );
//   console.log(allNullErrors);

//   if (
//     Object.keys(formErrors).length > 0 &&
//     !allNullErrors
//   ) {
//     console.log(formErrors);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//     toast.error("Please fill required details");
//   } else {
//     submitForm();
//   }
// } catch (error) {
//   console.error("Validation Error:", error);
// }
